// extracted by mini-css-extract-plugin
module.exports = {"AccordionTrigger":"FooterLinksList_AccordionTrigger__R3Ups","footerLinksCollapsibleContent":"FooterLinksList_footerLinksCollapsibleContent__XXHFh"};